module.exports = {
          srcSet: __webpack_public_path__ + "images/2007-6591ddbea48a2a495703e3590e4fcd4c-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2007-73348c3be7ade5dee43d282090e00093-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2007-6591ddbea48a2a495703e3590e4fcd4c-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2007-73348c3be7ade5dee43d282090e00093-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2007-6591ddbea48a2a495703e3590e4fcd4c-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2007-6591ddbea48a2a495703e3590e4fcd4c-320.jpg"},
          
          width: 320,
          height: 251
        }